<template>
    <nav>
        <div class="container">
            <menu>
                <ul>
                    <li>
                        <router-link tag="div" class="button-wrap" to="/accounts">
                            <a>Accounts</a>
                        </router-link>
                    </li>
                    <li>
                        <router-link tag="div" class="button-wrap" to="/prospects">
                            <a>Prospects</a>
                        </router-link>
                    </li>
                    <li>
                        <router-link tag="div" class="button-wrap" to="/website">
                            <a>Website</a>
                        </router-link>
                    </li>
                    <li>
                        <router-link tag="div" class="button-wrap" to="/libraries">
                            <a>Film Database</a>
                        </router-link>
                    </li>
                    <li>
                        <router-link tag="div" class="button-wrap" to="/employees">
                            <a>Employees</a>
                        </router-link>
                    </li>
                </ul>
            </menu>
        </div>
        <div class="bar"></div>
    </nav>
</template>

<script>
  import sizzle from 'sizzle'
  import velocity from 'velocity-animate'

  export default {
    props: ['authenticated'],
    mounted () {
      this.checkLogin()
    },
    methods: {
      checkLogin () {
        if (this.authenticated) {
          this.showMenu()
        } else {
          this.hideMenu()
        }
      },
      hideMenu () {
        velocity(sizzle('ul', this.$el), 'fadeOut', { duration: 50 })
      },
      showMenu () {
        velocity(sizzle('ul', this.$el), 'fadeIn', { duration: 50 })
      }
    },
    watch: {
      authenticated: {
        handler () {
          this.checkLogin()
        }
      }
    }
  }
</script>

<style rel="stylesheet/scss" type="text/css" lang="scss" scoped>
    nav {
        text-align: center;

        menu {
            height: 25px;

            ul {
                z-index: 10;
                position: relative;

                li {
                    display: inline-block;
                    list-style-type: none;
                    height: 25px;
                    line-height: 25px;
                    width: 200px;
                    text-align: center;
                    position: relative;
                    z-index: initial;
                    margin-left: -5px;

                    a {
                        text-decoration: none;
                        color: #000;
                        text-transform: uppercase;
                        display: inline-block;
                        height: 100%;
                        width: 100%;
                    }

                    .button-wrap {
                        height: calc(100% - 2px);
                        border-top: 2px solid #dbe1ea;
                        background: #fff;
                    }

                    .button-wrap:hover, .button-wrap.router-link-active {
                        background: #dbe1ea;
                    }
                }

                li:first-child {

                    .button-wrap:before {
                        content:"";
                        position:absolute;
                        background: #fff;
                        border-right: 3px solid #dbe1ea;
                        top:0;
                        left: -15px;
                        bottom: 0;
                        width: 28px;
                        -webkit-transform: skew(-50deg);
                        -moz-transform: skew(-50deg);
                        -ms-transform: skew(-50deg);
                        transform: skew(-50deg);
                    }
                }

                li:not(:first-child) {
                    a {
                        margin-left: -20px;
                    }

                    .button-wrap:before {
                        content:"";
                        position:absolute;
                        background: inherit;
                        border-left: 3px solid #dbe1ea;
                        top:0;
                        left: -15px;
                        bottom: 0;
                        width: 28px;
                        border-top: 2px solid #dbe1ea;
                        -webkit-transform: skew(50deg);
                        -moz-transform: skew(50deg);
                        -ms-transform: skew(50deg);
                        transform: skew(50deg);
                    }
                }

                li:last-child .button-wrap:after {
                    content:"";
                    position:absolute;
                    background: #fff;
                    border-left: 3px solid #dbe1ea;
                    top:0;
                    right: -15px;
                    bottom: 0;
                    width: 28px;
                    -webkit-transform: skew(50deg);
                    -moz-transform: skew(50deg);
                    -ms-transform: skew(50deg);
                    transform: skew(50deg);
                }
            }
        }
        
        .bar {
            height: 15px;
            background: #dbe1ea;
        }
    }
</style>


// WEBPACK FOOTER //
// menu.vue?4072307d